export default __webpack_public_path__ + "static/media/loopedhype.ed2cf089.png";